export default function(location: Location) {
  // const paths = location.pathname.split('/');
  // console.log(`activity platform: ${Date.now()}`);
  return true;
}
